export const defaultPreviousButton = {
  "@type": "@builder.io/sdk:Element",
  component: {
    name: "CarouselButton",
    options: {
      type: "previous",
      icon: "Circle Arrow",
    },
  },
};

export const defaultNextButton = {
  "@type": "@builder.io/sdk:Element",
  component: {
    name: "CarouselButton",
    options: {
      type: "next",
      icon: "Circle Arrow",
    },
  },
};

const defaultSlideImage = {
  "@type": "@builder.io/sdk:Element",
  "@version": 2,
  id: "builder-7609adcf5428475eac941f7cd19a9f63",
  meta: {
    previousId: "builder-61af0f791fb44ba29ec183351fb1f505",
  },
  component: {
    name: "Image",
    options: {
      image:
        "https://cdn.builder.io/api/v1/image/assets%2F481825b100e64e7f9a22a215d86e03f1%2F58b25f8387534c928a7980dbfc7e6ba0",
      backgroundSize: "cover",
      backgroundPosition: "center",
      lazy: false,
      fitContent: true,
      aspectRatio: 0.666,
      lockAspectRatio: false,
      height: 1253,
      width: 1880,
    },
  },
  responsiveStyles: {
    large: {
      position: "relative",
      width: "100%",
      minHeight: "20px",
      minWidth: "20px",
      overflow: "hidden",
      height: "150px",
      marginBottom: "20px",
    },
  },
};

const defaultSlideText = {
  "@type": "@builder.io/sdk:Element",
  "@version": 2,
  id: "builder-7a73b2b526124a5ba817db2d237af76a",
  meta: {
    previousId: "builder-932c3f7252134983a46cee29e7f5edb1",
  },
  component: {
    name: "Text",
    options: {
      text: "Carousel Slide - I'm editable",
    },
  },
};

export const defaultSlide = {
  "@type": "@builder.io/sdk:Element",
  "@version": 2,
  layerName: "Box",
  id: "builder-e3dfae48fc18445ca94c744bfee92ce8",
  meta: {
    previousId: "builder-c73f4763569e4b8e84dce1057654b7d4",
  },
  children: [defaultSlideImage, defaultSlideText],
  responsiveStyles: {
    large: {
      height: "400px",
      width: "auto",
      borderWidth: "3px",
      borderStyle: "solid",
      paddingTop: "10px",
      paddingLeft: "10px",
      paddingBottom: "10px",
      paddingRight: "10px",
      borderRadius: "10px",
    },
    small: {
      width: "auto",
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
};

export const defaultContentNav = {
  "@type": "@builder.io/sdk:Element",
  component: {
    name: "CarouselContentNav",
  },
};

export const defaultCarouselContent = {
  "@type": "@builder.io/sdk:Element",
  component: {
    name: "v1: CarouselContent",
    options: {
      slides: Array(6).fill(defaultSlide),
    },
  },
  responsiveStyles: {
    large: {
      marginLeft: "auto",
      marginRight: "auto",
    },
    small: {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
};
